import React from 'react';

export function Dashboard() {
  return <div>Task To Do (20)</div>;
}

export default Dashboard;
